<template>
  <div class="settles">
    <div class="head-box">
      <h4>结算单列表</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入结算单标题/结算单据号"
          v-model="searchValue"
          class="c-search"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew(1)" class="c-m-l-10">新增结算单</el-button>
        <!-- <el-button type="primary" @click="doNew(0)" class="c-m-l-10" v-has="'Settles,unlockPay'">
          新增未解付结算单
        </el-button> -->

        <el-dropdown class="c-m-l-10" @command="audit" v-has="'Settles,audit'">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
            <el-dropdown-item command="3">审核通过</el-dropdown-item>
            <el-dropdown-item command="4">审核不通过</el-dropdown-item>
            <el-dropdown-item command="5">反审</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="c-m-l-10" @command="audit" v-has="'Settles,submitAudit'">
          <el-button type="primary">
            提交审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectSettles"
          highlight-current-row
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="结算单标题" fixed width="200px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="结算单据号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="结算对象"
            width="120px"
            show-overflow-tooltip
            :formatter="formatType"
          ></el-table-column>
          <el-table-column
            prop="sourceType"
            label="结算来源类型"
            width="120px"
            show-overflow-tooltip
            :formatter="formatSourceType"
          ></el-table-column>
          <template v-if="tenantId != '3427214598959251213'">
            <el-table-column
              prop="sourceTypeType"
              label="类型"
              width="120px"
              show-overflow-tooltip
              :formatter="formatSourceTypeType"
            ></el-table-column>
            <el-table-column
              prop="toId"
              label="服务商"
              width="180px"
              show-overflow-tooltip
              :formatter="formatToId"
            ></el-table-column>
          </template>
          <el-table-column label="创建日期查询条件" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.startTime && scope.row.endTime">
                {{ scope.row.startTime.split(' ')[0] }} 至
                {{ scope.row.endTime.split(' ')[0] }}
              </template>
              <template v-else-if="scope.row.startTime">
                从 {{ scope.row.startTime.split(' ')[0] }} 开始
              </template>
              <template v-else-if="scope.row.endTime">
                截止到 {{ scope.row.endTime.split(' ')[0] }}
              </template>
              <template v-else>
                不限制
              </template>
            </template>
          </el-table-column>
          <el-table-column label="实际完工日期查询条件" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.exts.contractCompleteStartTime && scope.row.exts.contractCompleteEndTime
                "
              >
                {{ scope.row.exts.contractCompleteStartTime }} 至
                {{ scope.row.exts.contractCompleteEndTime }}
              </template>
            </template>
          </el-table-column>
          <template>
            <el-table-column label="结算单状态" width="150px">
              <template slot-scope="scope">
                <el-tag effect="plain" v-if="scope.row.settleState == 0">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
                <el-tag effect="dark" v-else-if="scope.row.settleState == 1">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
                <el-tag effect="dark" v-else-if="scope.row.settleState == 2" type="success">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
                <el-tag effect="dark" v-else-if="scope.row.settleState == 3" type="warning">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
                <el-tag effect="dark" v-else-if="scope.row.settleState == 4" type="danger">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
                <el-tag effect="dark" v-else-if="scope.row.settleState" type="info">
                  {{ formatSettleState(scope.row.settleState) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="签约状态" width="150px">
              <template slot-scope="scope">
                <el-tag effect="dark" type="success" v-if="scope.row.qysStatus == '10'">
                  已签约
                </el-tag>
                <el-tag effect="dark" type="primary" v-else-if="scope.row.qysStatus == '0'">
                  待签约
                </el-tag>
                <el-tag effect="plain" v-else-if="!scope.row.qysStatus">
                  未发起
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="签约方式" width="150px">
              <template slot-scope="scope">
                <el-tag effect="dark" type="primary" v-if="scope.row.qysTradeIn == 0">
                  线下签约
                </el-tag>
                <el-tag effect="dark" type="success" v-else-if="scope.row.qysTradeIn == 1">
                  线上签约
                </el-tag>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            width="150px"
          ></el-table-column>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                  <!-- v-has="'Settles,UnbindSX'" -->
                  <el-dropdown-item
                    v-has="'Settles,unbindSX'"
                    @click.native="doUnbindSX(scope.row._id)"
                  >
                    解绑结算单
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!-- 扩展字段 -->
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 
      结算对象 type
      0: 平台给服务商
      1: 雨虹给修链
      2: 修链给服务商
      3: 服务商给修链
      4: 修链给雨虹
      99: 推广大使
      -->
    <!-- 
      结算来源类型 sourceType
      0: 工单
      2: 合同
      3: 支付记录
      -->
    <el-dialog
      :title="items.unlockPayState ? '结算单' : '未解付结算单'"
      :visible.sync="openDetail"
      custom-class="c-dialog"
    >
      <el-form
        style="display: flex; flex-wrap: wrap"
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="150px"
        label-position="left"
        class="c-form-item"
      >
        <el-form-item label="结算单标题" prop="title">
          <el-input
            v-model="formData.title"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="tenantId != '3427214598959251213'"
          label="结算对象"
          prop="type"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="formData.type"
            clearable
            @change="filterConditionChange()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.type"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="结算来源类型"
          prop="sourceType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="formData.sourceType"
            clearable
            @change="
              formData.toId = '';
              formData.sourceTypeType = [];
              filterConditionChange();
            "
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <template v-for="item in options.sourceType">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>

        <!-- 结算来源类型为2:合同时展示 -->
        <template v-if="formData.sourceType == 2">
          <el-form-item
            label="合同类型"
            prop="sourceTypeType"
            :rules="{
              required: true,
              trigger: ['blur', 'change'],
              message: '请选择'
            }"
          >
            <el-select
              v-model="formData.sourceTypeType"
              clearable
              multiple
              @change="
                $forceUpdate();
                filterConditionChange();
              "
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <el-option
                v-for="item in options.contractType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="c-date-picker">
            <template slot="label">
              合同实际完工日期
            </template>
            <el-date-picker
              v-model="formData.contractCompleteTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="合同实际完工日期"
              end-placeholder="合同实际完工日期"
              clearable
              @change="filterConditionChange()"
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="信息来源" prop="exts.contractSourceType">
            <el-select
              v-model="formData.exts.contractSourceType"
              clearable
              @change="
                $forceUpdate();
                filterConditionChange();
              "
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <el-option
                v-for="item in options.contractSourceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否工程类项目" prop="exts.project_is">
            <el-select
              v-model="formData.exts.project_is"
              clearable
              @change="
                $forceUpdate();
                filterConditionChange();
              "
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <el-option
                v-for="item in options.project_is"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item
          label="选择服务商"
          prop="toId"
          :rules="{
            required: formData.sourceType == 2 ? true : false,
            trigger: 'change',
            message: '请选择'
          }"
          v-if="
            tenantId != '3427214598959251213' && (formData.sourceType || formData.sourceType == 0)
          "
        >
          <el-select
            v-model="formData.toId"
            clearable
            filterable
            @change="filterConditionChange(false, 'toId')"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.partners"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 结算来源类型为3:结算明细时展示 -->
        <!-- @change="filterConditionChange(true)" -->
        <el-form-item v-if="formData.sourceType == 3" label="结算明细状态" prop="settleItemState">
          <el-select
            v-model="formData.settleItemState"
            clearable
            @change="filterConditionChange()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.settleItemState"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.sourceType == 3" label="冻结状态" prop="freeze">
          <el-select
            v-model="formData.freeze"
            clearable
            @change="filterConditionChange()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.freeze"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 结算来源类型为2:合同时展示 -->
        <el-form-item
          v-if="formData.sourceType == 2"
          label="是否已结清"
          prop="payState"
          :rules="{
            required: false,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="formData.payState"
            clearable
            @change="
              $forceUpdate();
              filterConditionChange();
            "
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.payState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择动态表单 -->
        <!-- <el-form-item
          v-if="formData.sourceType == 4 || formData.sourceType == 6 || formData.sourceType == 7"
          label="选择表单"
          prop="sourceTypeName"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        > -->
        <el-form-item
          v-if="formData.sourceType == 4"
          label="选择表单"
          prop="sourceTypeName"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="formData.sourceTypeName"
            clearable
            @change="
              $forceUpdate();
              filterConditionChange('', '', formData.sourceTypeName);
            "
          >
            <el-option
              v-for="item in options.extForm"
              :key="item._id"
              :label="item.title"
              :value="item.colName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formData.sourceTypeName == 'contractSX'"
          label="施工员"
          prop="constructionUser"
          :rules="{
            required: false,
            trigger: ['blur', 'change']
          }"
        >
          <el-input
            :rows="1"
            v-model="formData.constructionUser"
            @change="filterConditionChange()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="c-date-picker" v-if="formData.sourceTypeName == 'contractSX'">
          <template slot="label">
            完工日期
          </template>
          <el-date-picker
            v-model="formData.datetimerange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="filterConditionChange()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="c-date-picker" v-else>
          <template slot="label">
            {{ formatSourceType(null, null, formData.sourceType) || ''
            }}{{ formData.sourceType == 2 ? '签订' : '创建' }}日期
          </template>
          <el-date-picker
            v-model="formData.datetimerange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="filterConditionChange()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="memo"
          :rules="{
            required: items.unlockPayState ? false : true,
            trigger: ['blur', 'change'],
            message: '备注不能为空'
          }"
        >
          <el-input
            :rows="1"
            v-model="formData.memo"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-input>
        </el-form-item>
        <!-- 其他过滤条件 -->
        <c-form
          style="width:100%;margin-left:0"
          label-width="150px"
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          class="extFields-form-item"
        ></c-form>
      </el-form>
      <div class="c-flex c-flex-end c-m-b-20">
        <el-button type="primary" @click="filterConditionSearch">查 询</el-button>
        <el-button @click="doNew(1)">重 置</el-button>
      </div>
      <!-- sourceType:0 工单列表 -->
      <el-table
        v-if="formData.sourceType == 0"
        ref="table0"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        class="c-table-border"
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          width="145px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单编号"
          width="120px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="name" label="客户名称" width="100px"></el-table-column>
        <el-table-column prop="phone" label="客户电话" width="120px"></el-table-column>
        <el-table-column
          prop="province"
          label="省"
          :formatter="osg.formatProvince"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="city"
          label="市"
          :formatter="osg.formatCity"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="district"
          label="区"
          :formatter="osg.formatDistrict"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          width="180px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="服务商"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="140px"
          sortable
        ></el-table-column>
        <el-table-column
          prop="paystate"
          label="支付状态"
          min-width="100px"
          :formatter="formatPayState"
        ></el-table-column>
        <el-table-column
          prop="unlockPayState"
          label="解付状态"
          min-width="100px"
          :formatter="formatUnlockPay"
        ></el-table-column>
        <el-table-column label="产品明细" width="500px">
          <template
            slot-scope="scope"
            v-if="scope.row.exts.productsSnap && scope.row.exts.productsSnap.length > 0"
          >
            <el-table :data="scope.row.exts.productsSnap">
              <el-table-column
                prop="name"
                label="规格"
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="price" label="单价"></el-table-column>
              <el-table-column prop="costNum" label="数量"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <!-- sourceType:2 合同列表 -->
      <el-table
        v-else-if="formData.sourceType == 2"
        ref="table2"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        class="c-table-border"
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column
          prop="contactsName"
          label="委托方"
          min-width="150px"
          fixed
        ></el-table-column>
        <el-table-column prop="partyB" label="服务商" min-width="150px"></el-table-column>
        <el-table-column prop="signedDate" label="签订日期" width="100"></el-table-column>
        <el-table-column
          prop="contractdocNum"
          label="合同编号"
          min-width="170px"
          fixed
        ></el-table-column>
        <el-table-column prop="contactsPhone" label="联系电话" min-width="100px"></el-table-column>
        <el-table-column
          prop="afterRefundMoney"
          label="合同金额"
          min-width="100px"
        ></el-table-column>
        <el-table-column prop="paidAmount" label="已支付金额" min-width="100px"></el-table-column>
        <!-- <el-table-column
            prop="settledCardinal"
            label="已结基数金额"
            min-width="100px"
          ></el-table-column> -->
        <!-- <el-table-column
            prop="settledAmount"
            label="已结算金额"
            min-width="100px"
          ></el-table-column> -->
        <el-table-column prop="teamLeader" label="工队长" min-width="100px"></el-table-column>
        <el-table-column prop="serviceHousekeeper" label="管家" min-width="100px"></el-table-column>
        <el-table-column
          prop="exts.repairParts"
          label="维修部位"
          min-width="150px"
          :formatter="formatRepairParts"
        ></el-table-column>
        <!-- <el-table-column
            prop="maintainAreaNum"
            label="维修面积"
            min-width="80px"
          ></el-table-column> -->
        <!-- <el-table-column label="质保年限" min-width="80px">
            <template slot-scope="scope" v-if="scope.row.warrantyPeriod">
              {{ scope.row.warrantyPeriod }}年
            </template>
          </el-table-column> -->
        <el-table-column label="开工日期" min-width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.startDate">
              {{ scope.row.startDate.split(' ')[0] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="完工日期" min-width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.endDate">
              {{ scope.row.endDate.split(' ')[0] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="实际完工日期" min-width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.exts.realCompleteDate">
              {{ scope.row.exts.realCompleteDate.split(' ')[0] }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="insurancedocNum"
            label="保单号"
            min-width="200px"
          ></el-table-column> -->
        <el-table-column
          prop="exts.contractStatus"
          label="签约状态"
          min-width="100px"
          :formatter="formatContractStatus"
        ></el-table-column>
        <el-table-column
          prop="payState"
          label="支付状态"
          min-width="100px"
          :formatter="formatPayState"
        ></el-table-column>
        <el-table-column
          prop="unlockPayState"
          label="解付状态"
          min-width="100px"
          :formatter="formatUnlockPay"
        ></el-table-column>
      </el-table>
      <!-- sourceType:3 支付记录 -->
      <el-table
        v-else-if="formData.sourceType == 3"
        ref="table3"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        class="c-table-border"
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <c-table :fields="settleItemFields">
          <template slot="rules">
            <el-table-column label="结算政策" width="500px">
              <template slot-scope="scope" v-if="scope.row && scope.row.rules.length > 0">
                <el-table :data="scope.row.rules" border class="c-table-border">
                  <el-table-column
                    prop="settleRule.name"
                    label="政策名称"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="settleRule.currentDeductType"
                    :formatter="formatDeductType"
                    label="扣减科目"
                  ></el-table-column>
                  <!-- <el-table-column prop="cardinal" label="基数金额(元)"></el-table-column> -->
                  <el-table-column prop="amountDeduct" label="实际平台服务费"></el-table-column>
                  <el-table-column label="结算数值">
                    <template slot-scope="scope2">
                      {{ scope2.row.settleRule.currentCalcTypeValue }}
                      {{ scope2.row.settleRule.currentCalcType == 0 ? '%' : '元' }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
          </template>
        </c-table>
      </el-table>
      <!-- sourceType：4 动态表单 -->
      <!-- <el-table
        v-else-if="
          (formData.sourceType == 4 || formData.sourceType == 6 || formData.sourceType == 7) &&
            this.formData.sourceTypeName
        "
        ref="table4"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        class="c-table-border"
        stripe
        @selection-change="selectChange"
      > -->
      <el-table
        v-else-if="formData.sourceType == 4 && this.formData.sourceTypeName"
        ref="table4"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        class="c-table-border"
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <c-table :fields="extFormFields"></c-table>
      </el-table>
      <div slot="footer">
        <div>
          共查询到
          <span class="c_blue">{{ items.fpi.data.length }}</span>
          条符合条件的数据，已选择
          <span class="c_blue">{{ items.selectedRows.length }}</span>
          条。
        </div>
        <div>
          <el-button type="primary" @click="doSave">提 交</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="审核不通过" :visible.sync="auditObj.show">
      <el-form ref="audit" :model="auditObj" label-width="100px" label-position="left">
        <el-form-item
          label="备注"
          prop="remark"
          placeholder="请输入备注内容"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入备注内容'
          }"
        >
          <el-input v-model="auditObj.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="auditConfirm('4', '审核不通过，处理完成。')">
          确 定
        </el-button>
        <el-button
          @click="
            auditObj.show = false;
            auditObj.remark = '';
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'Settles',
  data() {
    window.$this = this;
    return {
      name: 'settle',
      fpi: {},
      // 明细
      items: {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      },
      searchValue: '',
      openDetail: false,
      formData: {
        toId: '',
        sourceTypeType: [],
        datetimerange: [],
        contractCompleteTime: [],
        exts: {
          project_is: ''
        }
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_type: { codeId: 'settleType' }, //结算对象
        codecfg_sourceType: { codeId: 'settleSourceType' }, //结算来源类型
        codecfg_contractSourceType: { codeId: 'sourceType' }, //信息来源
        codecfg_contractType: { codeId: 'contractType' },
        codecfg_settleState: { codeId: 'settleState' },
        cascadeCode_repairParts: { codeId: 'repairParts' },
        codecfg_contractStatus: { codeId: 'contractStatus' },
        codecfg_payState: { codeId: 'payState1' },
        codecfg_unlockPay: { codeId: 'unlockPayState' },
        codecfg_project_is: { codeId: 'project_is' },
        codecfg_deductType: { codeId: 'deductType' },
        codecfg_freeze: { codeId: 'freeze' },
        extForm: [] //查询动态表单
      },
      selectedRows: [], //勾选的结算单
      auditObj: {
        show: false,
        remark: ''
      },
      // 结算明细字段
      settleItemFields: [],
      ExtFields: '', //扩展表单name
      tenantId: '', //获取缓存租户id
      filterCondition: {
        // 修改过滤条件传参
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.getFields('settle', () => {
      this.getPartners();
      this.getOrgs();
      this.getServiceResources();
      this.getExtForm();
      this.osg.codeoption(() => {
        this.osg.getFpi();
        this.getData();
        console.log(this.options, '-----options');
      });
    });
    this.osg.getFields('settleItem', () => {}, null, 'settleItemFields');
    this.osg.getFields('contractSX', () => {}, null, 'contractSXFields');
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    formatToId(row, column, cellValue) {
      if (row.sourceType == 0) {
        //工单
        return this.osg.codelabel('partnersOrgId', cellValue);
      } else {
        return this.osg.codelabel('partners', cellValue);
      }
    },
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatSourceType(row, column, cellValue) {
      return this.osg.codelabel('sourceType', cellValue);
    },
    formatSourceTypeType(row, column, cellValue) {
      if (row.sourceType == 2) {
        return this.osg.codelabelForArray('contractType', cellValue);
      }
    },
    formatSettleState(val) {
      return this.osg.codelabel('settleState', val);
    },
    formatRepairParts(row, column, cellValue) {
      if (cellValue) {
        return this.osg.formatCascade('repairParts', cellValue);
      }
    },
    formatContractStatus(row, column, cellValue) {
      if (!cellValue) {
        return '待签约';
      } else {
        return this.osg.codelabel('contractStatus', cellValue);
      }
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatUnlockPay(row, column, cellValue) {
      if (Array.isArray(cellValue)) {
        return cellValue.indexOf(Number(this.formData.type)) != -1 ? '已解付' : '未解付';
      } else {
        return this.osg.codelabel('unlockPay', cellValue);
      }
    },
    formatUserId(row, column, cellValue) {
      return this.osg.codelabel('serviceResources', cellValue);
    },
    formatTargetType(row, column, cellValue) {
      return cellValue == 1 ? '工单' : cellValue == 2 ? '合同' : cellValue;
    },
    formatSignDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue, 'date') : '';
    },
    formatEndDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue) : '';
    },
    formatDeductType(row, column, cellValue) {
      return this.osg.codelabel('deductType', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        toId: '',
        sourceTypeType: [],
        contractCompleteTime: [],
        exts: {
          project_is: ''
        }
      };
      this.items = {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      };
      this.$util.renderExtField(this.extFields, this.formData);
      this.$nextTick(() => {
        this.$refs.formData && this.$refs.formData.clearValidate();
      });
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:title|string#or': this.searchValue,
        'regex:num|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime,_id',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      this.osg.setFpi(params);
      this.osg.ajax('biz/settle/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew(unlockPayState) {
      this.doInit();
      this.items.unlockPayState = unlockPayState;
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row); //避免编辑内容后取消导致显示异常
      row.exts = row.exts || {};
      this.ExtFields = row.sourceTypeName || '';
      this.$util.renderExtField(this.extFields, row);
      // 组装datetimerange
      if (row.startTime && row.endTime) {
        row.datetimerange = [
          row.startTime && row.startTime.split(' ')[0],
          row.endTime && row.endTime.split(' ')[0]
        ];
      } else {
        row.datetimerange = [];
      }

      // 组装contractCompleteEndTime
      if (row.exts.contractCompleteStartTime && row.exts.contractCompleteEndTime) {
        row.contractCompleteTime = [
          row.exts.contractCompleteStartTime,
          row.exts.contractCompleteEndTime
        ];
      } else {
        row.contractCompleteTime = [];
      }

      this.$forceUpdate();

      row.sourceTypeType = row.sourceTypeType || [];
      row.toId = row.toId || ''; // 避免必填校验提前出现
      row.exts.project_is = row.exts.project_is || ''; //是否工程类项目

      this.formData = row;
      this.items.unlockPayState = this.formData.unlockPayState;
      this.filterCondition.edit = true;
      this.filterConditionSearch();
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      let params = this.$util.deepCopy(this.formData);
      params.settleState = params.settleState || 0;
      if (params.settleState != 0) {
        this.osg.alert('当前结算单状态不允许修改', () => {
          this.getData();
        });
        return;
      }
      if (this.osg.validate()) {
        params.startTime = params.startTime && params.startTime + ' 00:00:00';
        params.endTime = params.endTime && params.endTime + ' 23:59:59';
        // 结算来源id，targetType=0时为工单id，1时为订单id，2时为合同id, 3为结算明细id
        let sourceTypeIdList = [];
        for (var item of this.items.selectedRows) {
          if (sourceTypeIdList.indexOf(item._id) == -1) sourceTypeIdList.push(item._id);
        }
        if (sourceTypeIdList.length == 0) {
          this.osg.alert('请至少勾选一条数据!', 'warning');
          return;
        }
        params.sourceTypeIdList = sourceTypeIdList;

        // 付款方id（由结算对象来确定）
        switch (params.type) {
          case 0:
            params.fromId = '1340835581184723420';
            break;
          default:
            params.fromId = '';
        }
        // 解付状态
        params.unlockPayState = this.items.unlockPayState;

        // 保存完工日期筛选条件
        if (params.contractCompleteTime && params.contractCompleteTime.length > 0) {
          params.exts.contractCompleteStartTime = params.contractCompleteTime[0];
          params.exts.contractCompleteEndTime = params.contractCompleteTime[1];
        }
        delete params.contractCompleteTime;

        this.osg.ajax('biz/settle/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/settle/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getOrgs() {
      var params = {
        _all: '1',
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'org/query.do',
        params,
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.orgs = res.data.orgList;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getPartners() {
      var params = {
        _all: '1',
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.orgId;
          });
          this.options.partners = res.data;
          // 工单
          this.options.partnersOrgId = this.$util.deepCopy(this.options.partners);
          // this.options.partnersOrgId.map(item => {
          //   item.value = item.orgId;
          // });
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    // 获取服务资源-对工队结算
    getServiceResources() {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1',
          resourceType: 'technician'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.relatedRecordId;
          });
          this.options.serviceResources = res.data;
        }
      );
    },
    filterConditionChange(edit, field, ExtFields) {
      this.filterCondition.edit = edit;
      this.filterCondition.field = field;
      if (field == 'toId') {
        let partners = this.options.partners.filter(item => item.value == this.formData.toId);
        if (partners.length) {
          this.$set(this.formData, 'title', partners[0].name);
        }
      }
      if (ExtFields) {
        this.filterCondition.ExtFields = ExtFields;
      }
    },
    filterConditionSearch(edit, field, ExtFields) {
      edit = this.filterCondition.edit;
      field = this.filterCondition.field;
      ExtFields = this.filterCondition.ExtFields;
      // 必须选择结算来源类型才请求数据
      if (!this.formData.sourceType && this.formData.sourceType != 0) {
        return;
      }

      // 将服务商名称赋值给结算单标题
      // if (field == 'toId') {
      //   let partners = this.options.partners.filter(item => item.value == this.formData.toId);
      //   if (partners.length) {
      //     this.$set(this.formData, 'title', partners[0].name);
      //   }
      // }

      // 结算来源类型:工单
      if (this.formData.sourceType == 0) {
        this.getServiceAppointments(edit);
        return;
      }

      // 结算来源类型:合同
      if (this.formData.sourceType == 2) {
        this.getContracts(edit);
        return;
      }

      // 结算来源类型:支付记录（结算明细）
      if (this.formData.sourceType == 3) {
        this.getSettleItems(edit);
        return;
      }
      // 结算来源类型:刷新
      // if (
      //   (this.formData.sourceType == 4 ||
      //     this.formData.sourceType == 6 ||
      //     this.formData.sourceType == 7) &&
      //   this.formData.sourceTypeName
      // ) {
      if (this.formData.sourceType == 4 && this.formData.sourceTypeName) {
        this.osg.getFields(
          this.formData.sourceTypeName,
          () => {
            if (ExtFields) {
              this.ExtFields = ExtFields;
            }
            this.getExtFields(edit);
          },
          null,
          'extFormFields'
        );
        this.$forceUpdate();
        return;
      }
    },

    // 查询工单
    getServiceAppointments(edit) {
      // if (!this.formData.toId) {
      //   return;
      // }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      // 赋值contractCompleteTime
      this.formData.contractCompleteTime = this.formData.contractCompleteTime || [];

      this.items.loading = true;
      var params = {
        _all: '1',
        'gte:createTime|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:createTime|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        // 'gte:exts.realCompleteDateTime|date#and': this.formData.contractCompleteTime[0]
        //   ? this.formData.contractCompleteTime[0] + ' 00:00:00'
        //   : null,
        // 'lte:exts.realCompleteDateTime|date#and': this.formData.contractCompleteTime[1]
        //   ? this.formData.contractCompleteTime[1] + ' 23:59:59'
        //   : null,
        'nin:settlePayState|array-integer#or': this.formData.type,
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        'in:_id|array#or': this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // 过滤:解付条件
      if (this.items.unlockPayState) {
        params['in:unlockPayState|array-integer#and'] = this.formData.type;
      } else {
        params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      }

      if (this.formData.type == 1) {
        // 平台对工人结算
        params['is:exts.headManId|string#and'] = this.formData.toId;
      } else {
        // 平台对门店结算
        params['is:orgId|string#and'] = this.formData.toId;
      }

      // 新增未解付结算单页面，只展示支付了金额的合同
      // if (!this.items.unlockPayState) {
      //   params['in:payState|array-integer#and'] = '1,2';
      // }
      // 合同类型
      if (this.formData.sourceType == 2) {
        // exts中数组不能传
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table0.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询合同
    getContracts(edit) {
      if (!this.formData.toId) {
        this.items = {
          fpi: {
            data: []
          },
          selectedRows: [],
          loading: false
        };
        return;
      }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      // 赋值contractCompleteTime
      this.formData.contractCompleteTime = this.formData.contractCompleteTime || [];

      this.items.loading = true;
      var params = {
        _all: '1',
        'gte:signedDate|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:signedDate|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        'gte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[0]
          ? this.formData.contractCompleteTime[0] + ' 00:00:00'
          : null,
        'lte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[1]
          ? this.formData.contractCompleteTime[1] + ' 23:59:59'
          : null,
        'nin:settlePayState|array-integer#or': this.formData.type,
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        'in:_id|array#or': this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        'in:exts.sourceType|string#and': this.formData.exts.contractSourceType, //用于过滤合同的信息来源
        'exists:exts.settleMark|boolean#and': false,
        'is:partnerId|string#and': this.formData.toId,
        'in:state|array-integer#and': '1,0',
        // 加条件 settledCandidate 不等于0
        'exists:settledCandidate|boolean#and': true,
        'ne:settledCandidate|integer#and': 0,

        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // 筛选合同的支付状态
      if (!this.formData.payState) {
        params['in:payState|array-integer#and'] = '1,2';
      } else {
        params['is:payState|integer#and'] = this.formData.payState;
      }

      // 合同类型
      if (this.formData.sourceType == 2) {
        // exts中数组不能传
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        'basic/contract/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();
            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询结算明细
    getSettleItems(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }

      // 查询结算明细过滤参数
      var params = {
        _all: '1',
        // 过滤:结算明细创建时间范围
        'gte:createTime|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:createTime|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        // 过滤:结算对象
        'is:type|integer#and': this.formData.type,
        // TODO先不过滤否则没数据 过滤:结算来源类型
        // 'is:sourceType|string#and': this.formData.sourceType,
        // 过滤:服务商
        'is:orgId|string#and': this.formData.toId,
        // TODO:结算支付状态过滤
        // 'nin:settlePayState|array-integer#or': this.formData.type,
        // 过滤:结算明细没有结算单id的
        'exists:settleId|boolean#and': edit ? null : false,
        // 过滤:结算明细状态
        'is:settleItemState|integer#and':
          !this.formData.settleItemState && this.formData.settleItemState !== 0
            ? null
            : this.formData.settleItemState,
        'is:state|integer#and': 1,
        // 过滤:编辑时只展示已勾选的结算明细
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        'in:_id|array#or': this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        // 过滤结算明细冻结状态
        freeze: !this.formData.freeze && this.formData.freeze !== '0' ? null : this.formData.freeze,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // TODO过滤:解付状态判断
      // if (this.items.unlockPayState) {
      //   params['in:unlockPayState|array-integer#and'] = this.formData.type;
      // } else {
      //   params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      // }

      this.osg.ajax(
        'biz/settleItem/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table3.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    //刷新
    getExtFields(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }

      // 刷新过滤条件
      if (this.formData.sourceTypeName == 'contractSX') {
        var params = {
          _all: '1',
          // // 过滤:结算明细创建时间范围
          // 'gte:createTime|datetime#and':
          //   this.formData.startTime && this.formData.startTime + ' 00:00:00',
          // 'lte:createTime|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
          // 过滤:完工日期
          'gte:endDateExts|string#and': this.formData.startTime && this.formData.startTime,
          'lte:endDateExts|string#and': this.formData.endTime && this.formData.endTime,
          // 过滤:结算对象
          'is:type|integer#and': this.formData.type,
          'is:constructionUser|string#and': this.formData.constructionUser, //刷新合同施工员
          // TODO先不过滤否则没数据 过滤:结算来源类型
          // 'is:sourceType|string#and': this.formData.sourceType,
          // 过滤:服务商
          'is:orgId|string#and': this.formData.toId,
          // TODO:结算支付状态过滤
          // 'nin:settlePayState|array-integer#or': this.formData.type,
          // 过滤:结算明细没有结算单id的
          'exists:settleId|boolean#and': edit ? null : false,
          // // 过滤:结算明细状态
          // 'is:settleItemState|integer#and':
          //   !this.formData.settleItemState && this.formData.settleItemState !== 0
          //     ? null
          //     : this.formData.settleItemState,
          'is:state|integer#and': 1,
          // 过滤:编辑时只展示已勾选的结算明细
          // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
          'in:_id|array#or': this.formData.sourceTypeIdList
            ? this.formData.sourceTypeIdList.join()
            : null,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
      } else {
        var params = {
          _all: '1',
          // 过滤:结算明细创建时间范围
          'gte:createTime|string#and':
            this.formData.startTime && this.formData.startTime + ' 00:00:00',
          'lte:createTime|string#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
          // // 过滤:完工日期
          // 'gte:endDateExts|string#and':
          //   this.formData.startTime && this.formData.startTime + ' 00:00:00',
          // 'lte:endDateExts|string#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
          // 过滤:结算对象
          'is:type|integer#and': this.formData.type,
          'is:constructionUser|string#and': this.formData.constructionUser, //刷新合同施工员
          // TODO先不过滤否则没数据 过滤:结算来源类型
          // 'is:sourceType|string#and': this.formData.sourceType,
          // 过滤:服务商
          'is:orgId|string#and': this.formData.toId,
          // TODO:结算支付状态过滤
          // 'nin:settlePayState|array-integer#or': this.formData.type,
          // 过滤:结算明细没有结算单id的
          'exists:settleId|boolean#and': edit ? null : false,
          // // 过滤:结算明细状态
          // 'is:settleItemState|integer#and':
          //   !this.formData.settleItemState && this.formData.settleItemState !== 0
          //     ? null
          //     : this.formData.settleItemState,
          'is:state|integer#and': 1,
          // 过滤:编辑时只展示已勾选的结算明细
          // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
          'in:_id|array#or': this.formData.sourceTypeIdList
            ? this.formData.sourceTypeIdList.join()
            : null,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
      }

      // TODO过滤:解付状态判断
      // if (this.items.unlockPayState) {
      //   params['in:unlockPayState|array-integer#and'] = this.formData.type;
      // } else {
      //   params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      // }
      // if(edit){

      // }
      this.osg.ajax(
        `biz/extForm/queryByColName/${this.ExtFields}.do`,
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table4.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询动态表单
    getExtForm() {
      let params = {
        _all: '1',
        'in:state|array-integer#and': '1',
        'is:isSettle|string#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('biz/ext/query.do', params, res => {
        this.options.extForm = res.data;
      });
    },
    // 指定选中明细
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs['table' + this.formData.sourceType].toggleRowSelection(row);
        });
        this.$forceUpdate();
      } else {
        this.$refs['table' + this.formData.sourceType].clearSelection();
      }
    },
    // 选中明细行变化时触发
    selectChange(rows) {
      this.items.selectedRows = rows;
    },
    // 结算单列表多选
    selectSettles(rows) {
      this.selectedRows = rows;
    },
    // 审核
    audit(settleState) {
      /**
       * settleState
       * 0:待提交（服务商新建后是自由态-->状态设为0:待提交）
       * 1:待审核（服务商点提交审核-->状态改为1:待审核）
       * 2:撤回-动作（结算单状态为1未审核或4审核未通过时 服务商可以点撤回-->状态改为0:待提交）
       * 3:审核通过（平台点审核通过-->结算单状态改为2:审核通过）
       * 4:审核不通过（平台点审核通过-->结算单状态改为4:审核不通过）
       * 5:反审-动作（结算单状态为2或4已审核时 平台可以点反审-->结算单状态改为1:待审核）
       */
      // 至少选择一个结算单
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少选择一个结算单', 'warning');
        return;
      }
      // 判断选择的结算单状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (settleState) {
        case '1':
          for (let settle of this.selectedRows) {
            if (settle.settleState != '0') {
              this.osg.alert(`您选择的结算单"${settle.title}"状态 不符合"提交审核"条件`, 'warning');
              return;
            }
          }
          confirmMsg = '提交审核';
          msg = '提交成功，待审核。';
          break;
        case '2':
          for (let settle of this.selectedRows) {
            if (settle.settleState != '1' && settle.settleState != '4') {
              this.osg.alert(`您选择的结算单"${settle.title}"状态 不符合"撤回修改"条件`);
              return;
            }
          }
          confirmMsg = '撤回修改';
          msg = '撤回成功，可修改后重新提交。';
          break;
        case '3':
          for (let settle of this.selectedRows) {
            if (settle.settleState != '1') {
              this.osg.alert(`您选择的结算单"${settle.title}"状态 不符合"审核"条件`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '4':
          for (let settle of this.selectedRows) {
            if (settle.settleState != '1') {
              this.osg.alert(`您选择的结算单"${settle.title}"状态 不符合"审核"条件`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        case '5':
          for (let settle of this.selectedRows) {
            if (settle.settleState != '2' && settle.settleState != '4') {
              this.osg.alert(`您选择的结算单"${settle.title}"还未审核 不符合"反审"条件`);
              return;
            }
          }
          confirmMsg = '反审';
          msg = '反审处理完成，结算单状态改为待审核。';
          break;
        default:
      }
      // 确认框
      if (settleState != '4') {
        this.osg.confirm(`是否确认${confirmMsg}`, () => {
          this.auditConfirm(settleState, msg);
        });
      } else {
        this.auditObj.show = true;
      }
    },
    auditConfirm(settleState, msg) {
      if (settleState == '4') {
        if (!this.osg.validate('audit')) return;
      }
      let settleIds = [];
      this.selectedRows.map(item => {
        settleIds.push(item._id);
      });
      this.osg.ajax(
        `/biz/settle/repapprove/${settleState}.do`,
        {
          settleIds: settleIds.join(),
          remark: this.auditObj.remark || null
        },
        () => {
          this.osg.toast(msg);
          this.auditObj.remark = '';
          this.auditObj.show = false;
          this.getData();
        }
      );
    },
    // 刷新结算单解绑
    doUnbindSX(id) {
      this.osg.confirm('是否确认解绑？', () => {
        this.osg.ajax(`/unbindSettleItemSX/${id}.do`, {}, () => {
          this.osg.toast('解绑成功');
          this.getData();
        });
      });
    },
    handleRowClick(row) {
      //  $router.push({ path: `/Settle/${row._id}` })
      this.$router.push({
        path: `/Settle/${row._id}`
      });
      this.SetCachedViews({ params: row.title, action: `/Settle/${row._id}` });
    }
  }
};
</script>
<style lang="scss">
.settles .c-dialog.el-dialog {
  width: 90% !important;
  height: 90% !important;
  .el-dialog__body {
    padding: 20px !important;
  }
}
#app .settles .c-dialog.el-dialog {
  max-height: 90vh !important;
  margin: 5vh auto 5vh !important;
  margin-top: 5vh !important;
}
// .c-form-item > div:not(:last-child) {
//   width: 45%;
//   float: left;
// }
// .c-form-item > div:nth-child(even):not(:last-child) {
//   margin-left: 10%;
// }
.c-form-item > div {
  width: 45%;
  float: left;
}
.c-form-item > div:nth-child(even) {
  margin-left: 10%;
}
.extFields-form-item .el-form > div {
  width: 45%;
  float: left;
}
.extFields-form-item .el-form > div:nth-child(even) {
  margin-left: 10%;
}
.c-date-picker {
  height: 33px !important;
}
</style>
